import React from 'react';
import './Footer.css';
import logo from '../../assets/NSASLogo.png';
import { FaEnvelope, FaFacebook, FaInstagram, FaTiktok } from 'react-icons/fa';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-col">
            <img src={logo} alt="NSAS Logo" className="footer-logo" />
            <h4>NSAS @ Southeastern</h4>
            <p className="tagline">Connecting cultures. Empowering students.</p>
          </div>

          <div className="footer-col">
            <h5>Quick Links</h5>
            <ul className="footer-links">
              <li>
                <Link to="/events">Events</Link>
              </li>
              <li>
                <Link to="/gallery">Gallery</Link>
              </li>
              <li>
                <Link to="/members">Members</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h5>Get in Touch</h5>
            <p>
              <FaEnvelope className="icon" />
              <a href="mailto:nsas.slu@gmail.com">nsas.slu@gmail.com</a>
            </p>
            <div className="social-icons">
              <a href="https://www.facebook.com/Slunsas/" target="_blank" rel="noreferrer">
                <FaFacebook className="icon" />
              </a>
              <a href="https://www.instagram.com/nsas.slu/" target="_blank" rel="noreferrer">
                <FaInstagram className="icon" />
              </a>
              <a href="https://www.tiktok.com/@nsas.slu/" target="_blank" rel="noreferrer">
                <FaTiktok className="icon" />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Nepalese Student Association at Southeastern</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
